import { useApiQuery } from '@/api/main/query'
import { useToast } from '@/shared/hooks'
import { useEffect } from 'react'
import { disputsAPI } from '../api/endpoints'
import { DefaultDisputModel, DisputModel } from '../model/types'

export const useGetDisputData = ({ disputId }: { disputId: string }) => {
  const { addToast } = useToast()

  const query = useApiQuery<DisputModel>(
    ['disput', disputId],
    disputsAPI.getDisput(disputId),
    undefined,
    {
      enabled: Boolean(disputId),
    }
  )

  useEffect(() => {
    if (query.error) {
      addToast('Ошибка загрузки спора', query.error.message, 'error')
    }
  }, [query.error, addToast])

  return {
    disputData: query.data ?? DefaultDisputModel,
    ...query,
  }
}
